<template>
  <div>
    <div v-if="opportunities && opportunities.length">
      <div class="top-controls">
        <b-row>
          <b-col sm="10">
            <b-form inline>
              <b-input-group class="filter-group">
                <b-input-group-prepend is-text>
                  <font-awesome-icon icon="search" />
                </b-input-group-prepend>
                <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                <b-input-group-append>
                  <b-button @click="filter = null">Clear</b-button>
                </b-input-group-append>
              </b-input-group>

              
            </b-form>
          </b-col>
          <b-col sm="2">
            <b-button class="new-opportunity-button float-right" :to="{name: 'opportunityAdd'}">
              <font-awesome-icon icon="plus" /> New Opportunity
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-table striped 
              :items="opportunities"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
              @filtered="onFiltered"
              sortBy="opportunityCategory"
              small>
        <template slot="term" slot-scope="data">
          {{ data.item.term.description }}
        </template>
        <template slot="opportunityCategory" slot-scope="data">
          {{ data.item.opportunityCategory ? data.item.opportunityCategory.name : "" }}
        </template>
        <template slot="site" slot-scope="data">
          <router-link :to="{name: 'site', params: {siteId: data.item.site.siteId }}">{{ data.item.site.name }}</router-link>
        </template>
        <template slot="published" slot-scope="data">
          {{ published | trueOrFalse }}
        </template>
        <template slot="view" slot-scope="data">
          <router-link :to="{ name: 'opportunity', params: { opportunityId: data.item.opportunityId } }">View</router-link>
        </template>
      </b-table>
      <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
    </div>
    <p v-if="opportunities && !opportunities.length">There are no opportunities to show.</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fields: [
        { key: "name", label: "Name / Title", sortable: true },
        { key: "term" },
        { key: "opportunityCategory", label: "Category" },
        { key: "site" },
        { key: "published" },
        { key: "view", label: "" }
      ],
      currentPage: 1,
      perPage: 10,
      filter: null,
      totalRows: 0
    };
  },

  props: {
    opportunities: {
      type: Array,
      required: true
    }
  },

  watch: {
    opportunities: function() {
      this.totalRows = this.opportunities.length;
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
.top-controls {
  margin-bottom: 10px;
}

.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
  display: inline-flex;
}

.filter-group,
.new-opportunity-button {
  margin: 10px 0 15px 0;
}
</style>
